module.exports = __webpack_public_path__ + "static/media/magnifying-glass.18806a1e.svg";